export default {
    header: 'My favorites',

    active: 'Active',
    expired: 'Expired',
    expiresThisMonth: 'Application deadline this month',
    expiresThisWeek: 'Application deadline this week',
    expiresLater: 'Application deadline later',

    noActiveFavorites: 'You have no active favorite positions',
    noExpired: 'You have no expired favorite positions',
};
